export { default } from 'features/reward/routes/rewards-route';
